import { devConfig } from "@/api/apiAuth";

export const getCandle = async (kind, isHeikin) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/${
        isHeikin ? "heikin-candle" : "candle"
      }?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.result; // JSON 데이터 반환
  } catch (error) {
    console.error("Error fetching candle data:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getInitCandleLast = async (kind) => {

  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/candle?ticker=${kind}&limit=2`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    return data.result[1]; // JSON 데이터 반환
  } catch (error) {
    console.error("Error fetching candle data:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getInitCandleLastBefore = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/candle?ticker=${kind}&limit=2`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.result[0]; // JSON 데이터 반환
  } catch (error) {
    console.error("Error fetching candle data:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getTrendLine = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/multiple-trend?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching trend line:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getSrLine = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/sr?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching sr line:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getMarkers = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/rsi?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getSignalMarkers = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/signal?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching signal markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getSignalMarkersTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/entry-signal?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getBlinkerSignalTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/blinker-signal?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getBlinkerLineTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/blinker-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getLabelSignalTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/label-signal?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getRlsSignalTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/rls-signal?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getHighLineTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/high-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getLowLineTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/low-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getSeriesData = async (kind, url, data) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/${url}?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const res = await response.json();
    const result = res.result;

    for (let i = 0; i < result.length; i++) {
      data.forEach((list) => {
        list.array.push({
          time: result[i].time,
          value: result[i][list.name],
        });
      });
    }
  } catch (error) {
    console.error("Error fetching 3ma line:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getMACDRSI = async (kind, isHeikin) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/${
        isHeikin ? "heikin" : "candle"
      }-macd?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching macd rsi line:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getRSI = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/rsi?ticker=${kind}&limit=0`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching rsi line:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getSmartLineTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/smart-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getFilledLineTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/filled-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getUtSignal2Test = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/ut-signal2?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getCrossSignalTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/cross-signal?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getDivergenceSignalTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/divergence?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};
